import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
// import DrilldownTable from '../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
// import CustomButton from '../../../../../../Common/CustomButton/CustomButton';
import _ from 'lodash-es';
import { useDispatch, useSelector } from "react-redux";
import CustomButton from '../../../../../../../Common/CustomButton/CustomButton';
import DrilldownTable from '../../../../../Dashboard/DefaultDashboard/DrillDownReports/Common/DrilldownTable';
import { getCSCEselector } from '../../../../../../../../../redux/reducers/reducerSlices/CSCEReducer';
import { AppConstant } from '../../../../../../../../Assests/AppConstant';
// import { sagaActions } from "../../../../../../../../sagas/sagaActions";
const CSCEConfigList = (props) => {
    const { themeSelected, editClicked, disableAction, deleteClicked } = props;
    const { appConfigList, appConfigListLoader } = useSelector(getCSCEselector);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const csceAppConfigTitleDD = [
        { id: 'Id', name: 'S.No' },
        { id: 'AppIdentifier', name: 'App Identifier' },
        { id: 'AppName', name: 'App Name' },
        // { id: 'StartTime', name: 'Start Time' },
        // { id: 'EndTime', name: 'End Time' },
        { id: 'PrimaryBrandingColour', name: 'Primary Branding' },
        { id: 'SecondaryBrandingColour', name: 'Secondary Branding' },
        { id: 'PrimarTextColour', name: 'Primary Text' },
        { id: 'SecondaryTextColour', name: 'Secondary Text' },
        { id: 'BadgeColour', name: 'Badge Colour' },
        { id: 'DisableDescription', name: 'Disable Description' },
        { id: 'CreatedDate', name: 'Created on' },
        { id: 'actions', name: 'Actions' },
    ]



    const actionsButton = (ele, index) => {
        return (
            <div className='m-0 p-0 d-flex justify-content-center'>
                <CustomButton
                    title={`${!ele.AppStatus
                        ? AppConstant.commonStrings.enable
                        : AppConstant.commonStrings.disable
                        }`}
                    className={`${!ele.AppStatus ? " btnEnable-ss" : "btnDisable-ss"
                        } `}
                    onClick={() => disableAction(ele)}
                    disabled={false}
                >

                </CustomButton>
                &ensp;
                <CustomButton
                    title={'Edit'}
                    className={props.allowPermissionE ? 'addButton' : 'addButton'}
                    isLoading={false}
                    onClick={() => editClicked(ele)}
                    disabled={false}
                />
                &ensp;
                <CustomButton
                    title={'Delete'}
                    className={props.allowPermissionE ? 'addButton' : 'addButton'}
                    isLoading={false}
                    onClick={() => deleteClicked(ele)}
                    disabled={false}
                />
            </div>
        )
    }

    const formatListData = (data) => {

        return data && data.map((el, index) => {
            return {
                id: el.Id,
                0: (index + 1),
                1: el.AppIdentifier || '-',
                2: el.AppName || '-',
                // 3: el.StartTime || '-',
                // 4: el.EndTime || '-',
                3: el.PrimaryBrandingColour || '-',
                4: el.SecondaryBrandingColour || '-',
                5: el.PrimarTextColour || '-',
                6: el.SecondaryTextColour || '-',
                7: el.BadgeColour || '-',
                8: el.DisableDescription || '-',
                9: el.CreatedOn || '-',
                10: actionsButton(el, index),
            }
        })
    }

    return (
        <DrilldownTable
            themeSelected={themeSelected}
            bodyData={appConfigList && formatListData(appConfigList)}
            titleData={csceAppConfigTitleDD}
            showCollapse={false}
            showInput={false}
            showSort={false}
            // arrangeOrder={arrangeOrder}
            // arrangeKey={arrangeKey}
            drillDownReport={appConfigList}
            initiateDrillDownReport={appConfigListLoader}
            loaderArray={11}
            // sortingAction={sagaActions.WAREHOUSE_LIST_SORTING}
            subRoot={{ pathName: 'csceConfigAdmin' }}
            showUTCTime={false}
        />
    )
}

export default CSCEConfigList;